export default __webpack_public_path__ + "static/media/chevron.8020d819.svg";